import { Routes } from '@angular/router';

import { LogoutDetectionGuard } from './shared/guards/logout-detection.guard';
import { USER_PROFILE_SECTIONS } from './shared/constants/user-profile-navigation';

import { HomeComponent } from './components/home/home.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { RegisterComponent } from './components/register/register.component';
import { BuyerVerificationPageComponent } from './components/buyer-verification/buyer-verification-page/buyer-verification-page.component';
import { CartComponent } from './components/cart/cart.component';
import { ProductListComponent } from './components/product-list/product-list.component';
import { ProductDetailComponent } from './components/product-detail/product-detail.component';
import { BookingPageComponent } from './components/booking-page/booking-page.component';
import { MyGarageComponent } from './my-garage/my-garage.component';
import { OrdersDetailSummaryComponent } from './components/orders-detail-summary/orders-detail-summary.component';
import { OrderConfirmationComponent } from './components/order-confirmation/order-confirmation.component';
import { ProformaStatusComponent } from './components/proforma-status/proforma-status.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { TermsConditionComponent } from './components/terms-condition/terms-condition.component';
import { BlogStoriesListComponent } from './components/blog-stories-list/blog-stories-list.component';
import { BlogDetailComponent } from './components/blog-detail/blog-detail.component';
import { ViewOtherComponent } from './components/view-other/view-other.component';
import { ProfileFaqComponent } from './components/profile-faq/profile-faq.component';
import { WishlistComponent } from './components/wishlist/wishlist.component';
import { CouponsOffersComponent } from './components/coupons-offers/coupons-offers.component';
import { NotificationAlertComponent } from './components/notification-alert/notification-alert.component';
import { ScrapCertificateComponent } from './components/scrap-certificate/scrap-certificate.component';
import { CustomerSupportComponent } from './components/customer-support/customer-support.component';
import { SmsRedirectComponent } from './components/sms-redirect/sms-redirect.component';

const profileLegacyRedirects: Routes = USER_PROFILE_SECTIONS.map((section) => ({
  path: `user-profile/${section}`,
  redirectTo: `/user-profile?section=${section}`,
}));

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full',
  },
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: 'register',
    component: RegisterComponent,
  },
  {
    path: 'buyer-verification',
    component: BuyerVerificationPageComponent,
    canActivate: [LogoutDetectionGuard],
  },
  {
    path: 'cart',
    component: CartComponent,
  },
  {
    path: 'cart/:id',
    component: CartComponent,
  },
  {
    path: 'product-list',
    component: ProductListComponent,
  },
  {
    path: 'product-detail/:id',
    component: ProductDetailComponent,
  },
  {
    path: 'booking-page',
    component: BookingPageComponent,
  },
  {
    path: 'my-garage',
    component: MyGarageComponent,
  },
  {
    path: 'user-profile',
    component: UserProfileComponent,
    canActivate: [LogoutDetectionGuard],
  },
  ...profileLegacyRedirects,
  {
    path: 'orders-details',
    component: OrdersDetailSummaryComponent,
    canActivate: [LogoutDetectionGuard],
  },
  {
    path: 'order-status',
    component: OrderConfirmationComponent,
    canActivate: [LogoutDetectionGuard],
  },
  {
    path: 'order-confirmation',
    component: OrderConfirmationComponent,
    canActivate: [LogoutDetectionGuard],
  },
  {
    path: 'proforma-status',
    component: ProformaStatusComponent,
    canActivate: [LogoutDetectionGuard],
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'terms-condition',
    component: TermsConditionComponent,
  },
  {
    path: 'blog-stories',
    component: BlogStoriesListComponent,
  },
  {
    path: 'blog-detail/:id',
    component: BlogDetailComponent,
  },
  {
    path: 'view-other',
    component: ViewOtherComponent,
  },
  {
    path: 'profile-faq',
    component: ProfileFaqComponent,
    canActivate: [LogoutDetectionGuard],
  },
  {
    path: 'wishlist',
    component: WishlistComponent,
    canActivate: [LogoutDetectionGuard],
  },
  {
    path: 'coupons',
    component: CouponsOffersComponent,
    canActivate: [LogoutDetectionGuard],
  },
  {
    path: 'notification-alert',
    component: NotificationAlertComponent,
    canActivate: [LogoutDetectionGuard],
  },
  {
    path: 'scrap-certificate',
    component: ScrapCertificateComponent,
    canActivate: [LogoutDetectionGuard],
  },
  {
    path: 'customer-support',
    component: CustomerSupportComponent,
  },
  {
    path: 'i',
    component: SmsRedirectComponent,
  },
  {
    path: 'i/:id',
    component: SmsRedirectComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];
